export function getLeaveApiErrorMessage(error) {
  return error?.message?.trim() || null;
}

export function getLeaveApiSuccessMessage(response) {
  return (
    response?.data?.message?.trim() ||
    response?.message?.trim() ||
    null
  );
}

export function getActionByRemarks(response) {
  const remarks = response?.data?.actionByRemarks;
  if (remarks == null) return null;
  const text = String(remarks).trim();
  return text || null;
}

export function buildSuccessToast(response, { includeRemarks = true } = {}) {
  const message = getLeaveApiSuccessMessage(response);
  if (!message) return null;

  return {
    message,
    detail: includeRemarks ? getActionByRemarks(response) : null,
    type: "success",
  };
}
